export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/chevronDownGreen.37c96187.svg","height":8,"width":12,"blurWidth":0,"blurHeight":0};